import { getUpgradeSourceTypeFromUrl } from 'core/helpers'
import { isNuxtUpgradeHookLink } from 'core/upgradeLink'

/**
 * Routes an upgrade prompt the way UpgradeLink does, for the AVN-1396 free chat window prompts that are not links: Nuxt
 * sites get the hook (the URL carries upgradeSourceType, so the host goes straight to billing), sites that use an
 * upgrade popup open it, and everything else navigates to the upgrade page.
 *
 * Kept out of core/upgradeLink on purpose: core/helpers reads `navigator` when it loads, and the provider unit tests
 * load core/upgradeLink under Node, which has no `navigator` before v21 (CI runs 14).
 */
export const openUpgrade = (url, config) => {
  if (isNuxtUpgradeHookLink(url, config)) {
    config.hooks?.onBlockedMessage?.(getUpgradeSourceTypeFromUrl(url))
    return
  }
  if (url === 'OPEN_UPGRADE_POPUP') {
    config.hooks?.onOpenUpgradePopup?.()
    return
  }
  window.location.href = url
}
